<template>
  <div class="project-switch-btn" :title="props.collapsed ? currentProject?.name : undefined" @click="switchProject">
    <icon-vue v-if="props.collapsed" icon="fluent:folder-20-regular" :width="18" />
    <section v-else-if="currentProject" class="flex flex-row items-center gap-2">
      <icon-vue icon="fluent:folder-20-regular" :width="16" style="flex-shrink: 0" />
      <span class="project-name">{{ currentProject.name }}</span>
      <icon-vue icon="icon-park-outline:switch" :width="14" style="color: #86909c; flex-shrink: 0" />
    </section>
  </div>
</template>
<script setup lang="ts">
import showCommonProjectSwitch from '@/components/widgets/project-switch';
import type { SysProject } from '@/types/common';
import { PermissionPageKey } from '@/types/permission';
import { Icon as IconVue } from '@iconify/vue';
import { useRouter } from 'vue-router';

interface Props {
  projects: SysProject[];
  currentProject: SysProject;
  collapsed?: boolean;
}

const props = defineProps<Props>();
const router = useRouter();

/**
 * @description 项目切换
 */
function switchProject() {
  showCommonProjectSwitch({
    disabled: props.currentProject.id,
    onProjectEntry(p) {
      router.push({
        name: PermissionPageKey.ProjectDashboard,
        params: { pkey: p.pkey },
      });
    },
  });
}
</script>
<style scoped>
.project-switch-btn {
  background: #f7f8fa;
  color: #1d2129;
  border: none;
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s;
  user-select: none;
}

.project-switch-btn:hover {
  background: #e8f3ff;
}

.project-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
</style>
